import Cookies from 'browser-cookies';
import * as client from 'utils/client';
import asyncDispatcher from 'utils/asyncDispatcher';
import {
  APPLICATION_CREATION_REQUESTED,
  APPLICATION_CREATION_FAILED,
  APPLICATION_CREATED,
  APPLICATION_FETCH_REQUESTED,
  APPLICATION_FETCH_FAILED,
  APPLICATION_FETCHED,
  APPLICATION_UPDATE_REQUESTED,
  APPLICATION_UPDATE_FAILED,
  APPLICATION_UPDATED,
  APPLICATION_REWIND_REQUESTED,
  APPLICATION_REWIND_FAILED,
  APPLICATION_REWOUND
} from 'utils/constants';
import * as C from 'utils/constants';

const createApplication = (dispatch, getState) => {
  const { api } = getState().app;
  const uuid = client.getUuid() || client.generateUuid();

  return asyncDispatcher(dispatch, {
    action: api.createApplication(uuid),
    data: { requested: { uuid } },
    pending: APPLICATION_CREATION_REQUESTED,
    success: APPLICATION_CREATED,
    failure: APPLICATION_CREATION_FAILED
  });
}

const fetchApplication = (number, dispatch, getState) => {
  const { api } = getState().app;

  return asyncDispatcher(dispatch, {
    action: api.fetchApplication(number),
    data: { requested: { number } },
    pending: APPLICATION_FETCH_REQUESTED,
    success: APPLICATION_FETCHED,
    failure: APPLICATION_FETCH_FAILED
  });
}

export const getApplicationNumber = () => {
  return Cookies.get(C.APPLICATION_NUMBER);
}

export const setApplicationNumber = (number) => {
  Cookies.set(C.APPLICATION_NUMBER, number);
}

export const hasExistingApplication = () => {
  return !!getApplicationNumber();
}

export const createOrFetchApplication = () => (dispatch, getState) => {
  const number = getApplicationNumber();
  if (!number) {
    return createApplication(dispatch, getState);
  } else {
    return fetchApplication(number, dispatch, getState);
  }
}

export const restoreCurrentApplication = () => (dispatch, getState) => {
  const number = getApplicationNumber();
  if (number) {
    return fetchApplication(number, dispatch, getState);
  }
}

export const updateApplication = (application, form) => (dispatch, getState) => {
  const { api } = getState().app;

  return asyncDispatcher(dispatch, {
    action: api.updateApplication(application, form),
    data: { requested: { application, form } },
    pending: APPLICATION_UPDATE_REQUESTED,
    success: APPLICATION_UPDATED,
    failure: APPLICATION_UPDATE_FAILED
  });
}

export const rewindApplication = (application) => (dispatch, getState) => {
  const { api } = getState().app;

  return asyncDispatcher(dispatch, {
    action: api.rewindApplication(application),
    data: { requested: { application } },
    pending: APPLICATION_REWIND_REQUESTED,
    success: APPLICATION_REWOUND,
    failure: APPLICATION_REWIND_FAILED
  });
}

export const submitXeroApplication = (form, organisation_id) => (dispatch, getState) => {
  const { api } = getState().app;

  return asyncDispatcher(dispatch, {
    action: api.submitXeroApplication(form, organisation_id),
    data: { requested: { form, organisation_id } },
    pending: APPLICATION_REWIND_REQUESTED,
    success: APPLICATION_REWOUND,
    failure: APPLICATION_REWIND_FAILED
  }).then((data) => {
    dispatch({
      type: APPLICATION_FETCHED,
      data
    })
  });
}



// WEBPACK FOOTER //
// ./src/actions/applications.js